module.exports = __webpack_public_path__ + "media/images/xpass/markers/inactive/akt-ddcdb319ab20a9107bb4fc90a085bb94.png";